import Raven from 'raven-js';
import { useAsyncEffect } from 'react-utils/hooks/useAsyncEffect';
import { MagpieConnection } from 'magpie-lib/connection';
import { UtilityMessages, utilityTopicDef } from '../topics/utility';
import { navigate } from '../../utils/common';
import { waitForConnectedMagpie } from '../../utils/magpie';

export const useRegisterHostNavigate = () => {
  useAsyncEffect(async () => {
    await waitForConnectedMagpie();
    const connection = MagpieConnection.get();
    const unsubscribe = connection
      .useTopic(utilityTopicDef)
      .on(UtilityMessages.hostNavigateMessage.getType(), (message) => {
        const { location, newTab } = message.payload;
        try {
          navigate(location, newTab);
        } catch (error) {
          Raven.captureException(error as Error);
        }
      });
    return () => unsubscribe();
  }, []);
};
